import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
	AlertComponent,
	FilePreviewComponent,
	InfoGroupComponent,
	ModalComponent,
	TagComponent,
	TileComponent,
} from '@tecalisdev/infinity';
import { transformDate } from '../../../../../../core/utils/utils';
import { DatePipe } from '@angular/common';
import {
	BOOLEAN_STATUS,
	IOperationOcrDetail,
	IOperationPolDetail,
} from '../../../../../../processes/models/processes.models';
import { firstOcrFrontPreviewUrl } from '../../../../../../processes/utils/ocr-admin-images.util';

@Component({
	selector: 'app-modal-data-comparison',
	imports: [
		TranslatePipe,
		DatePipe,
		ModalComponent,
		TileComponent,
		AlertComponent,
		FilePreviewComponent,
		InfoGroupComponent,
		TagComponent,
	],
	templateUrl: './modal-data-comparison.component.html',
	styleUrl: './modal-data-comparison.component.scss',
})
export class ModalDataComparisonComponent implements OnInit {
	@Input() polImages?: IOperationPolDetail['images'];
	@Input() ocrImages?: IOperationOcrDetail['images'];
	@Input() ages?: { low_age: string; high_age: string };
	@Input() birthdate?: string;
	@Input() polAntifraud?: IOperationPolDetail['antifraud'];

	@Output() closeEvent = new EventEmitter<void>();

	public yearsOld?: number;

	public shouldShowAlertForAntifraudStatus(status: BOOLEAN_STATUS | string | undefined): boolean {
		return status !== BOOLEAN_STATUS.OK;
	}

	public get showFaceAlert(): boolean {
		return this.shouldShowAlertForAntifraudStatus(this.polAntifraud?.FACIAL_RECOGNITION);
	}

	public get showAgeAlert(): boolean {
		return this.shouldShowAlertForAntifraudStatus(this.polAntifraud?.FACIAL_RECOGNITION);
	}

	/** NIF-1027: anverso coherente (ocr_preview o legacy). */
	public get ocrFrontPreviewUrl(): string | undefined {
		return firstOcrFrontPreviewUrl(this.ocrImages);
	}

	ngOnInit(): void {
		this.yearsOld = this.getYearsOld();
	}

	private getYearsOld(): number {
		if (this.birthdate) {
			const birthDate = transformDate(this.birthdate);
			if (birthDate) {
				const today = new Date();
				let age = today.getFullYear() - birthDate.getFullYear();
				const m = today.getMonth() - birthDate.getMonth();
				if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
					age--;
				}
				return age;
			}
		}
		return 0;
	}
}
